export enum TopListTableType {
  WINS = 'wins',
  PLAYERS = 'players',
}
